// @flow

import * as React from 'react';
import { get } from 'lodash';
import styles from './Colors.scss';
import useCard from './hooks';
import { WIKI_ENTITIES } from '@services/boards/types';
import { ColorCard, VARIANT } from '../../../../components/ColorCard';
import classNames from 'classnames';

const {
  PRIMARY_COLORS,
  SECONDARY_COLORS
} = WIKI_ENTITIES;

type CardTypes = {
  selected: Boolean,
  block: {
    getEntityAt: (number) => void,
  },
  blockType: String,
  contentState: {
    getEntity: (string) => void,
    replaceEntityData: (string) => void,
  },
  onUpdate?: Function,
  onAdd?: Function,
  onRemove?: Function,
  onDelete?: Function,
  data?: Object,
  index?: Number
};

const VARIANTS_MAP = {
  [PRIMARY_COLORS]: 'primary',
  [SECONDARY_COLORS]: 'secondary',
};

const Colors = React.forwardRef(({
  data,
  index,
  selected,
  contentState,
  block,
  blockType,
  onUpdate,
  onAdd,
  onRemove,
  onDelete
}: CardTypes, ref) => {
  const {
    CONTEXT,
    entity,
    handleUpdate,
    handleDelete,
    handleFocus,
    handleBlur,
    handleAdd,
    handleRemove,
  } = useCard({
    contentState,
    block,
    onUpdate,
    onAdd,
    onRemove,
    onDelete,
  });

  const isLast = index === entity.entities.length - 1;
  const isEdit = get(CONTEXT, 'isEdit');
  const variant = VARIANTS_MAP[blockType];

  return (
    <>
      <ColorCard
        variant={variant}
        mode={isEdit ? 'edit' : 'read'}
        data={data}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onUpdate={handleUpdate}
        onRemove={handleRemove}
      />
      {
        isEdit
        && isLast
        && (
          <button
            className={classNames(styles.AddButton, {
              [styles.AddButtonVariantPrimary]: variant === VARIANT.PRIMARY,
              [styles.AddButtonVariantSecondary]: variant === VARIANT.SECONDARY,
            })}
            onClick={handleAdd}
            onFocus={handleFocus}
            onBlur={handleBlur}
          >
            <div className={styles.TemplateCirclePlus}></div>
            <div className={styles.TemplateTitle}>
              Add new card
            </div>
          </button>
        )
      }
    </>
  )
});

export default Colors;
